import type {
  GameContext,
  GameInstance,
  GameModule,
  PreloadContext,
} from '@arcraz/arcadia-types';
import { DemoInstance } from './instance.js';

const module_: GameModule = {
  id: 'demo',
  title: 'DEMO',
  manufacturer: 'ARCADIA AMUSEMENTS',
  year: 1984,
  genre: 'arena',
  resolution: { w: 480, h: 270 },
  pixelated: true,
  paletteHint: ['#00d9ff', '#ff00aa', '#ffea00', '#27e060'],
  validatorVersion: 1,
  controls: [
    { keys: 'ARROWS', action: 'MOVE' },
    { keys: 'Z', action: 'CYCLE COLOR' },
  ],

  async preload(_ctx: PreloadContext): Promise<void> {
    /* nothing to preload */
  },

  init(ctx: GameContext): GameInstance {
    return new DemoInstance(ctx);
  },
};

export default module_;
